import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { GiveawayRequirementType } from '@manifoldxyz/redeem-client';
import InfoDisplay from '@/components/InfoDisplay.vue';
import EmailRequirement from '@/components/requirements/EmailRequirement.vue';
import TwitterRequirement from '@/components/requirements/TwitterRequirement.vue';
import { RequirementWithCollectorData } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'Requirement',
  props: {
    requirement: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const requirementTypes = {
  [GiveawayRequirementType.EMAIL]: {
    component: EmailRequirement,
  },
  [GiveawayRequirementType.TWITTER_FOLLOW]: {
    component: TwitterRequirement,
  },
  [GiveawayRequirementType.TWITTER_LIKE]: {
    component: TwitterRequirement,
  },
  [GiveawayRequirementType.TWITTER_RETWEET]: {
    component: TwitterRequirement,
  },
};

const component = computed(() => {
  return requirementTypes[props.requirement.type].component;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
      requirement: props.requirement,
      disabled: props.disabled
    }, null, 8, ["requirement", "disabled"])),
    (props.requirement.error)
      ? (_openBlock(), _createBlock(InfoDisplay, {
          key: 0,
          description: props.requirement.error,
          type: "error"
        }, null, 8, ["description"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})